
const SavingsSection = () => {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-br from-[#2B5BA6] to-[#1e3d73] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 font-poppins px-4 leading-tight">
            Transparent Pricing, Exceptional Value
          </h2>
          <p className="text-base sm:text-lg text-white/90 max-w-3xl mx-auto px-4 leading-relaxed">
            We execute with top quality workmanship at the lowest price in the marketplace. We've saved homeowners millions of dollars from their lowest roofing estimates every year since 2021.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-10 sm:mb-12 lg:mb-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 sm:p-6 lg:p-8 border border-white/20">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#FF9500] mb-2 leading-tight">Millions</div>
            <div className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 leading-tight">Saved Since 2021</div>
            <p className="text-white/80 text-sm sm:text-base leading-relaxed">We've saved homeowners millions of dollars from their lowest roofing estimates every year.</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 sm:p-6 lg:p-8 border border-white/20">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#FF9500] mb-2 leading-tight">100%</div>
            <div className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 leading-tight">Transparent Pricing</div>
            <p className="text-white/80 text-sm sm:text-base leading-relaxed">Pay only for materials and labor. Our flat fee structure means no hidden margins or surprise costs.</p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 sm:p-6 lg:p-8 border border-white/20 sm:col-span-2 lg:col-span-1">
            <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#FF9500] mb-2 leading-tight">FREE*</div>
            <div className="text-lg sm:text-xl font-semibold mb-2 sm:mb-3 leading-tight">Price Guarantee</div>
            <p className="text-white/80 text-sm sm:text-base leading-relaxed">We guarantee to be below your estimated price or our service is completely FREE.</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-5 sm:p-6 lg:p-12">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8 text-center px-4 leading-tight">
            Why Our Customers Pay Less
          </h3>
          
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-8">
            <div>
              <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">Traditional Roofing Company:</h4>
              <div className="space-y-2 sm:space-y-3 text-gray-700">
                <div className="flex justify-between p-2.5 sm:p-3 bg-red-50 rounded-lg text-sm sm:text-base">
                  <span>Materials &amp; Labor</span>
                  <span className="font-semibold">$15,000</span>
                </div>
                <div className="flex justify-between p-2.5 sm:p-3 bg-red-50 rounded-lg text-sm sm:text-base">
                  <span>Marketing Costs</span>
                  <span className="font-semibold">$3,000</span>
                </div>
                <div className="flex justify-between p-2.5 sm:p-3 bg-red-50 rounded-lg text-sm sm:text-base">
                  <span>Sales Commission</span>
                  <span className="font-semibold">$4,000</span>
                </div>
                <div className="flex justify-between p-2.5 sm:p-3 bg-red-50 rounded-lg text-sm sm:text-base">
                  <span>Company Overhead</span>
                  <span className="font-semibold">$3,000</span>
                </div>
                <div className="flex justify-between p-3 sm:p-4 bg-red-100 rounded-lg border-2 border-red-300">
                  <span className="font-bold text-base sm:text-lg">Your Total Cost:</span>
                  <span className="font-bold text-base sm:text-lg">$25,000</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">Our Transparent Pricing:</h4>
              <div className="space-y-2 sm:space-y-3 text-gray-700">
                <div className="flex justify-between p-2.5 sm:p-3 bg-green-50 rounded-lg text-sm sm:text-base">
                  <span>Materials (Premium)</span>
                  <span className="font-semibold">$8,000</span>
                </div>
                <div className="flex justify-between p-2.5 sm:p-3 bg-green-50 rounded-lg text-sm sm:text-base">
                  <span>Pre-Negotiated Labor</span>
                  <span className="font-semibold">$7,000</span>
                </div>
                <div className="flex justify-between p-2.5 sm:p-3 bg-green-50 rounded-lg text-sm sm:text-base">
                  <span>Our Flat Fee</span>
                  <span className="font-semibold">$2,000</span>
                </div>
                <div className="flex justify-between p-2.5 sm:p-3 bg-green-50 rounded-lg text-sm sm:text-base">
                  <span className="text-gray-400 line-through text-xs sm:text-sm">Hidden Margins</span>
                  <span className="font-semibold text-green-600">$0</span>
                </div>
                <div className="flex justify-between p-3 sm:p-4 bg-green-100 rounded-lg border-2 border-green-300">
                  <span className="font-bold text-base sm:text-lg">Your Total Cost:</span>
                  <span className="font-bold text-base sm:text-lg">$17,000</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-gradient-to-r from-[#FF9500]/10 to-[#2B5BA6]/10 rounded-xl text-center">
            <div className="text-2xl sm:text-3xl font-bold text-[#2B5BA6] mb-2 leading-tight">You Save: $8,000</div>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed px-4">
              Premium materials. Expert craftsmanship. Transparent pricing. That's the difference.
            </p>
          </div>

          <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-gray-50 rounded-xl">
            <p className="text-sm sm:text-base text-gray-700 text-center leading-relaxed">
              <strong>Our Promise:</strong> You only pay for the roofing materials, while our pre-negotiated labor rates keep costs low. We make our money solely through a pre-agreed flat fee — no hidden margins, no surprise pricing — so you can feel confident that you're getting the best value for your investment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SavingsSection;
